"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;
var FlatFilter_1 = require("./FlatFilter");
/** Create a single CSS class from a set of classes or conditional classes. */
function join() {
    var potentials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        potentials[_i] = arguments[_i];
    }
    // Edge is stubborn and adds commas anyways. Let's replace them with spaces.
    return FlatFilter_1.flatfilter(potentials)
        .join(" ")
        .replace(/,/g, " ");
}
exports.join = join;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/Join.js
// module id = 62
// module chunks = 8